import React from 'react';

interface MapProps {
  className?: string;
  height?: number;
}

export function Map({ className = '', height = 450 }: MapProps) {
  return (
    <div className={`rounded-lg overflow-hidden shadow-lg ${className}`}>
      <iframe
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2618.387636967262!2d21.388153983404614!3d52.42915873724314!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x471edc33cfa829c7%3A0x229340b8f7155607!2sKryszta%C5%82owa%20171%2C%2005-240%20Krusze!5e1!3m2!1sen!2spl!4v1757274831017!5m2!1sen!2spl"
        width="100%"
        height={height}
        style={{ border: 0 }}
        allowFullScreen
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
        title="Lokalizacja Fundacji Znajdki"
        className="w-full"
      />
    </div>
  );
}